import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

interface ActivationLinkResponse {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  is_active: boolean;
}

export const useResendActivationLink = () => {
  const resendActivationLink = async ({
    customerId,
    userId
  }: {
    customerId: number;
    userId: number;
  }) => {
    const response = await Axios.post<ActivationLinkResponse>(
      POST_URL(customerId.toString(), userId.toString()).resendActivationLink
    );
    return response.data;
  };

  return useMutation<
    ActivationLinkResponse,
    AxiosError<BaseError>,
    { customerId: number; userId: number }
  >(resendActivationLink, {
    useErrorBoundary: false
  });
};
